import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, ArrowLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/portal";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      navigate(res.user.role === "admin" ? "/admin" : from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[#0A0A0A]">
        <img src="https://images.unsplash.com/photo-1643142314913-0cf633d9bbb5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 flex flex-col justify-end p-12">
          <h2 className="font-heading font-black text-white text-4xl tracking-tighter leading-tight">
            Your operating system,<br />always within reach.
          </h2>
          <p className="text-white/60 mt-4 max-w-sm">Sign in to access your documents, downloads, and updates.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary mb-10">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
          <h1 className="font-heading font-black text-3xl tracking-tight">Welcome back</h1>
          <p className="text-muted-foreground mt-2">Sign in to your Centennial account.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            {error && <div className="bg-destructive/10 text-destructive text-sm px-4 py-3 border border-destructive/20" data-testid="login-error">{error}</div>}
            <div>
              <label className="text-sm font-medium block mb-2">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                className="w-full border border-border px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary" />
            </div>
            <div>
              <label className="text-sm font-medium block mb-2">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                className="w-full border border-border px-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full bg-primary text-white py-3.5 font-semibold btn-lift disabled:opacity-60 inline-flex items-center justify-center gap-2">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign in"}
            </button>
          </form>

          <p className="text-sm text-muted-foreground mt-6">
            No account? <Link to="/register" className="text-primary font-semibold">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
